import type { COUNTRY } from '@shared/core-types';

import type { SecuritySettingsFeature } from '../types';
import { securitySettings as AT } from './AT';
import { securitySettings as CZ } from './CZ';
import { securitySettings as RO } from './RO';
import { securitySettings as SK } from './SK';

type BusinessCountry = Extract<COUNTRY, 'AT' | 'RO' | 'CZ' | 'SK'>;
export const securitySettingsBusinessFeatureMap: Record<BusinessCountry, SecuritySettingsFeature> =
    {
        AT,
        CZ,
        RO,
        SK,
    };
